import React from 'react';
import { TextField } from '@mui/material';

interface DescriptionFieldProps {
    description: string;
    error?: string;
    onChange: (value: string) => void;
}

export const DescriptionField: React.FC<DescriptionFieldProps> = ({
    description,
    error,
    onChange
}) => {
    return (
        <TextField
            label="Description"
            value={description}
            onChange={(e) => onChange(e.target.value)}
            error={!!error}
            helperText={error}
            fullWidth
            size="small"
            required
        />
    );
};
